module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1209.ce1c0f2b.png";